<template>
  <div class="alxq2">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
        <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd(hsk)" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img
                  src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg"
                  alt=""
                />
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox"></div>
    <div class="alxqboxbox">
      <div class="alxqbox">
        <div class="text text1">2021 - 6 - 16</div>
        <div class="text text2">教培市场落地营销方案</div>
        <div class="text text3">
          爆品商城，是米创科技旗下重要的服务商家的工具。其功能为提供商家端爆品采购。
          <br />
          今天，推荐的爆品营销方案主要针对 教培市场 。
          <br />

          高考已于月初结束，中考也已于近日落下帷幕。身处教培市场的你，是否在为暑假招生引流发愁呢？

          <br />
          对于教培机构来说， 招生
          是最重要的事情。毕竟同行竞争加剧，且各机构提供的服务相差都不多，再加之国家对教培市场整体的规范，综合下来，会导致招生一如既往没有头绪，营销活动可能也不痛不痒。
          为了解决“为营销而营销”的老大难为题，今天给大家讲解一组爆品商城的落地营销方案，无论处于教培市场上的哪一环，是教培市场上的哪类机构，均可直接复制。
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/jpsc1.15afe8f.png"
            alt=""
          />
        </div>
        <div class="text text3">
          先免费试学，如满意3000学费赠5000大礼包
          <br />
          99元试学3节课，全部上完后，全额返还；如后续满意续费，学费充3000即可获赠5000元学习礼品大礼包。
          <br />

          礼包涵盖：儿童电话手表、筋膜枪、颈部按摩仪、云南白药牙膏、腾讯动漫联名电动牙刷
          方案思路：零成本试学引流客户，三节课激发兴趣与达成销售。3000元稳定现金流，5000元大礼包促成交。实际大礼包成本534元，达成引流-获客-成交闭环的营销落地活动。
        </div>

        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/jpsc2.a948859.png"
            alt=""
          />
        </div>
        <div class="text text3">
          <br />
          进店了解，朋友圈转发即送288元电动牙刷，限量前88名
          <br />
          基于教培市场的本地化属性较强这一事实，用价值感强的电动牙刷作为到店引流激励。准备简短转发朋友圈信息，到店转发朋友圈即送。
          <br />

          方案思路：
          增加到店；借众人之手为我方宣传造势，影响本地更多准用户。电动牙刷实际成本29元，可根据情况适量放宽或缩减名额。
        </div>

        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/jpsc3.6b017de.png"
            alt=""
          />
        </div>
        <div class="text text3">
          <br />
          零元学，交多少送多少
          <br />
          免费试学，试学结束后学费一次性交多少送多同价值的产品。产品可自由组合选择。
          <br />

          方案思路：
          免费试学提前一步找准客户，交多少送多少激发客户大额交费欲望，产品自由组合给予客户更多选择权。
        </div>
        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/jpsc4.2e5648a.png"
            alt=""
          />
        </div>

        <div class="gjcanwxwbqqbox">
          <div class="gjcanwxwbqqleft"></div>
          <div class="gjcanwxwbqqright">
            <div
              @click="shareToQQ()"
              class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg1"
            ></div>
            <div
              @click="WeixinJSBridge()"
              class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg2"
            ></div>
            <div
              @click="shareToMicroblog()"
              class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg3"
            ></div>
          </div>
        </div>
        <div class="hengxian"></div>
        <div class="xgaltext">相关案例</div>
        <div class="xgalbox">
          <div @click="tiaozhuan(1)" class="xgalboxs xgalboxs1">
            <div class="xgalboxstext">饺子馆会员制简单有效促使精准回流</div>
          </div>
          <div @click="tiaozhuan(2)" class="xgalboxs xgalboxs2">
            <div class="xgalboxstext">健身俱乐部引流锁客经典案</div>
          </div>
          <div @click="tiaozhuan(3)" class="xgalboxs xgalboxs3">
            <div class="xgalboxstext">
              用2个步骤，一周新增628客户，营收91万！
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk: 1,
    };
  },
  mounted() {},
  methods: {
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        // share_url: "http://www.micreat.com/#/"
        share_url: "http://www.micreat.com?projectId=1",
      };
      // var qqqq = "https://connect.qq.com/widget/shareqq/index.html?url=" +
      var qqqq =
        "https://api.pwmqr.com/qrcode/create/?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&desc=" +
        share.desc;

      window.open(qqqq, "newwindow", "height=400,width=400,top=200,left=600");
    },
    //分享到QQ空间(可用)
    WeixinJSBridge() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        share_url: "http://www.micreat.com?projectId=1",
      };
      var wwww =
        "https://api.pwmqr.com/qrcode/create/?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&desc=" +
        share.desc;

      window.open(wwww, "newwindow", "height=400,width=400,top=200,left=600");
    },
    //分享到微博(可用)
    shareToMicroblog() {
      //自定义内容
      const share = {
        title: "米创集团",
        image_url: ["https://api.mxl.mclandian.com/images/favicon.ico"],
        share_url: "http://www.micreat.com/#/",
      };
      //跳转地址
      var bbbb =
        "https://service.weibo.com/share/share.php?url=" +
        encodeURIComponent(share.share_url) +
        "&title=" +
        share.title +
        "&pic=" +
        share.image_url +
        "&searchPic=true";

      window.open(bbbb, "newwindow", "height=1000,width=1000,top=200,left=100");
    },
    tiaozhuan(e) {
      if (e == 3) {
        this.$router.push({
          path: "/alxq5",
        });
      } else if (e == 2) {
        this.$router.push({
          path: "/alxq4",
        });
      } else if (e == 1) {
        this.$router.push({
          path: "/alxq2",
        });
      }
    },
    ydd(e) {
      if (e == 1) {
        this.hsk = 2;
      } else {
        this.hsk = 1;
      }
      console.log(this.hsk);
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.alxq2 {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1501.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
  }
  .alxqboxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.8rem;
    .alxqbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.1rem;
      .imgbox {
        width: 10rem;
        height: 5rem;
        background: #0f0;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        background: url("../../assets/images/1625137306(1).jpg") no-repeat
          center;
      }
      .text {
        display: flex;
        justify-content: center;
        align-items: left;
      }
      .text1 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #626262;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin-bottom: 0.9rem;
      }
      .text3 {
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 0.4rem;
        margin-bottom: 0.87rem;
      }
      .gjcanwxwbqqbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .gjcanwxwbqqleft {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .gjcanwxwbqqright {
          display: flex;
          justify-content: center;
          align-items: center;
          .gjcanwxwbqqrightimg {
            width: 0.3rem;
            height: 0.3rem;
            background-size: 100% 100%;
            margin-left: 0.5rem;
          }
          .gjcanwxwbqqrightimg1 {
            background: url("../../assets/images/qqt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg2 {
            background: url("../../assets/images/wxt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg3 {
            background: url("../../assets/images/wbt.png") no-repeat center;
          }
        }
      }
      .hengxian {
        width: 100%;
        height: 0.01rem;
        background: #efefef;
        margin-bottom: 0.8rem;
      }
      .xgaltext {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        margin-bottom: 0.5rem;
      }
      .xgalbox {
        display: flex;
        flex-wrap: wrap;
        .xgalboxs {
          width: 3.86rem;
          height: 2.89rem;
          background-size: 100% 100%;
          margin-right: 0.2rem;
          position: relative;
          .xgalboxstext {
            width: 387px;
            height: 52px;
            background: rgba($color: #010206, $alpha: 0.3);
            position: absolute;
            bottom: 0;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.15rem;
            box-sizing: border-box;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .xgalboxs1 {
          background: url("../../assets/images/a3.png") no-repeat center;
        }
        .xgalboxs2 {
          background: url("../../assets/images/a1.png") no-repeat center;
        }
        .xgalboxs3 {
          background: url("../../assets/images/a2.png") no-repeat center;
        }
        .xgalboxs:nth-child(3n) {
          margin-right: 0rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/alxq10/index.vue